// A checkout the user started while signed out. Stashed on click, then picked
// up by PendingCheckoutResumer once they've signed up + onboarded, so the pass
// they chose opens automatically against their real (linked) account.
export const PENDING_CHECKOUT_KEY = "pendingCheckout";

export type PendingCheckout = {
  planId: string;
  rewardId?: string;
  /** Where to send them after a successful payment (usually the page they were on). */
  returnUrl?: string;
};

// Ignore a stash older than this so a bailed sign-up can't trigger a surprise
// Stripe redirect on some later, unrelated sign-in.
const PENDING_CHECKOUT_TTL_MS = 30 * 60 * 1000;

export function setPendingCheckout(value: PendingCheckout): void {
  try {
    localStorage.setItem(
      PENDING_CHECKOUT_KEY,
      JSON.stringify({ ...value, savedAt: Date.now() }),
    );
  } catch {
    // ignore (private mode / storage disabled)
  }
}

/** Read and remove the pending checkout (one-shot; ignored if stale). */
export function takePendingCheckout(): PendingCheckout | null {
  try {
    const raw = localStorage.getItem(PENDING_CHECKOUT_KEY);
    if (!raw) return null;
    localStorage.removeItem(PENDING_CHECKOUT_KEY);
    const parsed = JSON.parse(raw) as PendingCheckout & { savedAt?: number };
    if (!parsed?.planId) return null;
    if (parsed.savedAt && Date.now() - parsed.savedAt > PENDING_CHECKOUT_TTL_MS) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
